import mixpanel from "mixpanel-browser";

const MIXPANEL_TOKEN = "28edead44af903f52c7dade738c29f4c";
const MIXPANEL_API_HOST = "https://am.captions.ai";

const instance = mixpanel.init(
  MIXPANEL_TOKEN,
  {
    api_host: MIXPANEL_API_HOST,
    persistence: "localStorage",
  },
  "oasis"
);

export function trackOasisPageView({ userId, route }: { userId: string; route: string }) {
  instance.identify(userId);
  instance.track("oasis_session_page_view", {
    platform: "oasis",
    route,
    user_id: userId,
  });

  if (import.meta.env.DEV) {
    console.log("Oasis page view", { route, userId });
  }
}

export function resetOasisAnalyticsIdentity() {
  instance.reset();
}
